import { Component, OnInit, Input, ViewChild, AfterViewInit, OnDestroy, Output, EventEmitter, input, signal } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ReportService } from '../../shared/report.service';
import { Report } from '../../classes/reports/report';
import { ReportBlock } from '../../classes/reports/report-block';
import { ReportConfig } from '../../classes/reports/report-config';


@Component({
  selector: 'app-report-block-render',
  templateUrl: './report-block-render.component.html',
  styleUrls: ['./report-block-render.component.css'],
  standalone: false
})
export class ReportBlockRenderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('blockRef', { static: true }) blockElement;

  reportCollection = input<{ id: number }>(null);
  reportConfigCollection = input<any>(null);

  block = input.required<ReportBlock>();
  report = input.required<Report>();

  reportConfig = input.required<ReportConfig>();

  private blockSubscription: any;
  refresh: any[];
  blockReady = signal<boolean>(false);

  data = signal<any>(null);
  noData = signal<boolean>(false);
  master = signal<any>(null);

  @Output() onLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private reportService: ReportService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.getBlock();
  }

  getBlock() {
    console.log('getBlock() Version 2');

    this.blockReady.set(false);
    this.refresh = [];

    this.reportService.getBlockDataV2(this.report().id, this.block(), this.reportConfig()).then(blockResults => {

      if (!blockResults) {
        this.noData.set(true);
        console.log('no data', this.noData());
        this.onLoaded.emit(true);

        this.blockReady.set(true);

        return;
      }

      const isGateway = !!(blockResults.master.gateway?.id && blockResults.master.gateway.id === this.reportConfig().forGateways[0]?.id);
      const isCollection = blockResults.master.collectionId && blockResults.master.collectionId === this.reportConfig().forCollections[0];

      if (blockResults && blockResults.block === this.block() && blockResults.data && (isGateway || isCollection)) {
        this.master.set(blockResults.master);
        this.prepareData(blockResults);
        this.blockReady.set(true);
        this.onLoaded.emit(true);
      }
    });
  }

  prepareData(blockResults) {
    this.data.set(null);
    if (this.block().fragment_id === 1) {
      this.prepareData1(blockResults.data);
    } else if (this.block().fragment_id === 2) {
      this.prepareData2(blockResults.data);
    } else if (this.block().fragment_id >= 3 && this.block().fragment_id <= 99) {
      // Component prepares the data
      this.data.set(blockResults.data);
      this.refresh = [Math.random()];
    }
  }

  /**
   * see https://www.alessioatzeni.com/meteocons/
   */
  prepareData2(data) {
    let tableData;
    const co = 0;
    this.data.set([]);
    let dayFrom;
    for (let week = 0; week <= 1; week++) {
      tableData = [];

      if (week === 0) {
        dayFrom = new Date(this.master().startAt);
        // dayTo = 20;
      } else {
        dayFrom = new Date(this.master().previousStartAt);
        // dayTo = 13
      }
      for (let idx0 = 0; idx0 < 7; idx0++) {
        const dayx = dayFrom.getDate();
        let value = { type: '', temp: 0, pressure: 0, icon: '' };
        for (let idx = 0; idx < data[week].length; idx++) {
          if (data[week][idx].dayNumber == dayx) {
            value = data[week][idx];
            switch (value.type) {
              case 'Sunny day ☀️':
                value.icon = 'B';
                break;
              case 'Cloudy ☁️':
                value.icon = 'N';
                break;
              case 'Mist ????':
                value.icon = 'E';
                break;
              case 'Overcast ☁️':
                value.icon = 'Y';
                break;
              case 'Partly cloudy (day) ⛅️':
                value.icon = 'H';
                break;
              case 'Light snow ????':
                value.icon = 'U';
                break;
              case 'Drizzle ????':
              case 'Light rain shower (day) ????':
              case 'Light rain ????':
                value.icon = 'Q';
                break;
              case 'Heavy rain ????':
                value.icon = '8';
                break;
              case 'Fog ????':
                value.icon = 'M';
                break;
              default:
                value.icon = ')';// Weather type not available.
                break;
            }
          }
        }
        tableData.push(value);
        dayFrom.setDate(dayFrom.getDate() + 1);
      }

      this.data.update(data => {
        data.push(tableData);
        return data;
      });
    }
    this.refresh = [Math.random()];
    this.blockReady.set(true);
  }

  prepareData1(data) {
    const hours = [];
    for (let idx = 0; idx < 24; idx++) {
      hours.push(idx + ':00');
    }

    const chartData = {
      labels: hours,
      datasets: []
    };
    const datasets = [];
    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    let co = 0;
    const dt = new Date(this.master().startAt);
    // Loop through the startAt days for the week
    for (let idx0 = 0; idx0 < 7; idx0++) {
      const dayx = dt.getDate();
      const daySet = { label: days[co], borderColor: this.reportService.colourForDay(days[co]), data: [], fill: false };
      // Loop through the days hours
      for (let hourx = 0; hourx < 24; hourx++) {

        let value = 0;
        for (let idx = 0; idx < data.length; idx++) {

          if (data[idx].dayNumber === dayx && data[idx].hourOfDay === hourx) {

            value = data[idx].value;
          }
        }
        daySet.data.push(value);
      }
      chartData.datasets.push(daySet);
      co++;
      dt.setDate(dt.getDate() + 1);
    }
    this.data.set(chartData);
    this.blockReady.set(true);
    this.refresh = [Math.random()];
  }

  ngAfterViewInit() {
    const block = this.blockElement.nativeElement;
  }

  ngOnDestroy() {
    if (this.blockSubscription) {
      this.blockSubscription.unsubscribe();
    }
  }
}
